import { cx } from 'linaria';
import { cssTheme } from '@uds/theme-utils';
import './loader.stylesheet_fscbjy.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import { isNumeric } from '@ux/js';
import './shimmer.stylesheet_19tg7jc.css';

let Size;
(function (Size) {
  Size["SMALL"] = "SMALL";
  Size["MEDIUM"] = "MEDIUM";
  Size["LARGE"] = "LARGE";
})(Size || (Size = {}));
let Animation;
(function (Animation) {
  Animation["WUB"] = "WUB";
  Animation["PULSE"] = "PULSE";
})(Animation || (Animation = {}));

const loader = "l169wtfe";
const loaderSize = {
  SMALL: "sn30awf",
  MEDIUM: "mzc8cbz",
  LARGE: "l1dc88xf"
};
const circle = "c60lni0";
const circle1 = "c1nr1kqq";
const circle1Animation = {
  PULSE: "p17bnz3c",
  WUB: "w1744dlf"
};
const circle2 = "crit03l";
const circle2Animation = {
  PULSE: "pr5c82i",
  WUB: "wplmwn4"
};
const getClassNames = _ref => {
  let {
    size,
    animation
  } = _ref;
  const hasAnimation = animation != null;
  return {
    root: cx(loader, size != null && loaderSize[size]),
    circle1: cx(circle, circle1, hasAnimation && circle1Animation[animation]),
    circle2: cx(circle, circle2, hasAnimation && circle2Animation[animation])
  };
};
const createDynamicVars = _ref2 => {
  let {
    color,
    gu
  } = _ref2;
  return {
    '--loader-color': color != null ? color : null,
    '--loader-size': gu != null ? `calc(${gu} * ${cssTheme.gu1})` : null
  };
};

const Loader = _ref => {
  let {
    size = Size.MEDIUM,
    animation,
    color,
    gu
  } = _ref;
  const classNames = getClassNames({
    size,
    animation
  });
  const dynamicVars = createDynamicVars({
    color,
    gu
  });
  return /*#__PURE__*/jsxs("div", {
    className: classNames.root,
    style: dynamicVars,
    children: [/*#__PURE__*/jsx("div", {
      className: classNames.circle1,
      style: dynamicVars
    }, "circle1"), /*#__PURE__*/jsx("div", {
      className: classNames.circle2,
      style: dynamicVars
    }, "circle2")]
  }, "root");
};
Loader.displayName = 'Loader';
var Loader$1 = Loader;

const WubLoader = props => /*#__PURE__*/jsx(Loader$1, {
  animation: Animation.WUB,
  ...props
});
WubLoader.displayName = 'WubLoader';
var WubLoader$1 = WubLoader;

const PulseLoader = props => /*#__PURE__*/jsx(Loader$1, {
  animation: Animation.PULSE,
  ...props
});
PulseLoader.displayName = 'PulseLoader';
var PulseLoader$1 = PulseLoader;

const toCssUnit = x => isNumeric(x) ? `${x}px` : x;
const root = "rr4jlh7";
const line = "l1snjh6m";
const multipleLines = "m1u2ze4b";
const classNames = {
  root: cx(root),
  line,
  multipleLines
};
const getDynamicVars = _ref => {
  let {
    width,
    height,
    duration
  } = _ref;
  return {
    '--shimmer-width': width != null && toCssUnit(width),
    '--shimmer-height': height != null ? toCssUnit(height) : cssTheme.gu2,
    '--shimmer-animation': duration != null && duration
  };
};

const random = seed => {
  const x = Math.sin(seed != null ? seed : 1) * 10000;
  return x - Math.floor(x);
};
const Shimmer = _ref => {
  let {
    lines = 1,
    width = '100%',
    height,
    randomSeed = 1,
    duration = '1.33s'
  } = _ref;
  const linesComponents = [];
  for (let i = 0; i < lines; i += 1) {
    linesComponents.push( /*#__PURE__*/jsx("div", {
      className: classNames.line,
      style: {
        width: lines > 1 ? `${random(randomSeed + i) * 100}%` : 'auto'
      }
    }, i));
  }
  return /*#__PURE__*/jsx("div", {
    className: cx(classNames.root, lines > 1 && classNames.multipleLines),
    style: getDynamicVars({
      width,
      height,
      duration
    }),
    children: linesComponents
  });
};
Shimmer.displayName = 'Shimmer';
var Shimmer$1 = Shimmer;

export { PulseLoader$1 as PulseLoader, Shimmer$1 as Shimmer, Size, WubLoader$1 as WubLoader };
